const KIND_DPO = 'DPO'
const KIND_OBSERVER = 'OBSERVER'
const KIND_CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS'

const KIND_LABELS = {
  [KIND_DPO]: 'DPO',
  [KIND_OBSERVER]: 'Observador',
  [KIND_CUSTOMER_SUCCESS]: 'Customer Success',
}

const organizations = {
  KIND_DPO,
  KIND_OBSERVER,
  KIND_CUSTOMER_SUCCESS,
  KIND_LABELS,
}

export default organizations
